// extracted by mini-css-extract-plugin
module.exports = {"button-holder":"AccountPushToAppCardCard_button-holder__iWkCc"};